import React from 'react'
const currentYear = new Date().getFullYear();
function Footer() {
    return (
        <>
            
 <footer className="container-fluid text-left text-lg-start crypt-footer mt-5 animation-element">
        <div className="container mt-5 in-view">
          <div className="row mt-5 pt-3 justify-content-center">
            <div className="col-12 col-sm-12 col-lg-4 pb-5 text-center">
              {/* Content */}
              <div className="mb-4">
                {/* Logo */}
                <div className="crypt-logo dark">
                  <a href="template-1.html">
                    <img src="assets/images/logo.png" alt="" />
                  </a>
                </div>
                <div className="crypt-logo light">
                  <a href="template-1.html">
                    <img src="assets/images/logo.png" alt="" />
                  </a>
                </div>
                <p className="card-text mt-2">Empowering traders with automated arbitrage intelligence.</p>
                <p className="card-text mt-2">Suite 305, Griffith Corporate Centre, Beachmont, Kingstown, St. Vincent and the Grenadines</p>
              </div>
              {/* <div className="text-left social-icons mt-4">
                <a href rel="nofollow" target="_blank">
                  <img src="assets/images/social/x.svg" alt="" width={24} />
                </a>
                <a href rel="nofollow" target="_blank">
                  <img src="assets/images/social/facebook.svg" alt="" width={24} />
                </a>
                <a href rel="nofollow" target="_blank">
                  <img src="assets/images/social/instagram.svg" alt="" width={24} />
                </a>
                <a href rel="nofollow" target="_blank">
                  <img src="assets/images/social/tiktok.svg" alt="" width={24} />
                </a>
              </div> */}
            </div>
           
          </div>
          {/* Copyright */}
          <div className="text-center p-4 mt-4 crypt-footer-copyright">
            Copyright © {currentYear} - Xperia Capital.
          </div>
        </div>
      </footer>

        </>
    )
}

export default Footer